import { goTo } from './browserLocation';

const isEmptyOrNull = (obj) => {
    if (obj === null || obj === "") {
        return true;
    } else {
        for(let key in obj) {
            if(obj.hasOwnProperty(key)) return false;
        }
        return true;
    }
}

const openUrl = url => {
    if (typeof url !== 'string' || !url.trim()) return;
    let parsedUrl;
    try {
        parsedUrl = new URL(url, window.location.origin);
    } catch {
        return;
    }
    if (parsedUrl.protocol !== 'http:' && parsedUrl.protocol !== 'https:') return;
    url = parsedUrl.href;
    const newWindow = window.open(url);

    if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
        goTo(url);
        return;
    }
    // window.open(url) hands the page this tab as window.opener; sever it so the opened site cannot
    // navigate the portal (reverse tabnabbing). A window whose opener cannot be severed is not kept.
    try {
        newWindow.opener = null;
    } catch (e) {
        newWindow.close();
        goTo(url);
    }
};

export { isEmptyOrNull, openUrl }